import { CaseType, LinkObject } from "../model";

export const ALL_ORG_STRUCTURES = "All";

export interface CustomerUserCaseTypeOrgStructures {
    value: CaseType;
    orgStructures: LinkObject[];
    includeLinkedImmunisationCases?: boolean;
}

export const getEmailDomain = (emailAddress: string) => {
    if (emailAddress?.includes("@")) {
        const emailElements = emailAddress.split("@");
        const emailDomain = "@" + emailElements[1];
        return emailDomain;
    }
    return "";
};
